import { Button, Space, Tag, Tooltip } from "antd";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import { EditOutlined, EyeOutlined, FilePdfOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { rightsService } from "../../../../services/rightsService";

export const columnsCommissions = (editTauxCommissions) => [
    {
        title: 'N° Police',
        dataIndex: 'numeroPolice',
        key: 'numeroPolice',
        render: (text) => <span style={{ fontWeight: 600, color: '#242166' }}>{text}</span>
    },
    {
        title: 'Souscripteur',
        dataIndex: 'souscripteur',
        key: 'souscripteur',
    },
    {
        title: 'Montant Prime',
        dataIndex: 'primeNette',
        key: 'primeNette',
        render: (_, record) => (
            <span style={{ fontWeight: 500 }}>
                {record.data.montant ? displayNumbers(record.data.montant) : 0}  FCFA
            </span>
        )
    },
    {
        title: 'Commission',
        dataIndex: 'commission',
        key: 'commission',
        render: (_, record) => (
            <>
                {record.data.commission ? displayNumbers(
                    record.data.commission
                ) : 0} FCFA
            </>
        )
    },
    {
        title: 'Statut',
        dataIndex: 'commissionPaye',
        key: 'commissionPaye',
        render: (_, record) => (
            <Tag
                color={record.data.commissionPaye ? '#52c41a' : '#1890ff'}
                style={{ borderRadius: '6px', fontWeight: 500 }}
            >
                {record.data.commissionPaye ? 'REGLÉ' : 'NON REGLÉ'}
            </Tag>
        ),
    },
    {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
            <Space size="small">
                {!record.data.commissionPaye && rightsService("HLA045") ? (
                    <>
                        {/* <Tooltip title="Payer commission">
                            <Button
                                type="primary"
                                icon={<CreditCardOutlined />}
                                size="small"
                                style={{
                                    background: '#52c41a',
                                    borderRadius: '6px'
                                }}
                            />
                        </Tooltip> */}
                        <Tooltip title="Modifier taux">
                            <Button
                                icon={<EditOutlined />}
                                size="small"
                                style={{
                                    borderColor: '#242166',
                                    color: '#242166',
                                    borderRadius: '6px'
                                }}
                                onClick={() => editTauxCommissions(record)}
                            />
                        </Tooltip>
                    </>
                ) : (
                    <Tooltip title="Télécharger reçu">
                        <Button
                            danger
                            icon={<FilePdfOutlined />}
                            size="small"
                            style={{ borderRadius: '6px' }}
                        />
                    </Tooltip>
                )}
            </Space>
        ),
    },
];


export const columnsContrats = (navigate) => [
    {
        title: 'N° Police',
        dataIndex: 'numeroPolice',
        key: 'numeroPolice',
        render: (text) => <span style={{ fontWeight: 600, color: '#242166' }}>{text}</span>
    },
    {
        title: 'Souscripteur',
        dataIndex: 'souscripteur',
        key: 'souscripteur',
    },
    {
        title: 'Date Effet',
        dataIndex: 'dateEffet',
        key: 'dateEffet',
    },
    {
        title: 'Date Échéance',
        dataIndex: 'dateEcheance',
        key: 'dateEcheance',
    },
    {
        title: 'Statut',
        dataIndex: 'regle',
        key: 'regle',
        render: (status) => (
            <Tag
                color={status === 'REGLE' ? '#52c41a' : '#1890ff'}
                style={{ borderRadius: '6px', fontWeight: 500 }}
            >
                {status}
            </Tag>
        ),
    },
    {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
            <Space size="small">
                <Tooltip title="Voir détails">
                    <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        size="small"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                        style={{
                            background: '#1890ff',
                            borderRadius: '6px'
                        }}
                    />
                </Tooltip>
                {/* {record.regle !== 'REGLE' && (
                    <Tooltip title="Régler">
                        <Button
                            type="primary"
                            icon={<CreditCardOutlined />}
                            size="small"
                            style={{
                                background: '#52c41a',
                                borderRadius: '6px'
                            }}
                        />
                    </Tooltip>
                )} */}
                {/* <Tooltip title="Télécharger PDF">
                    <Button
                        danger
                        icon={<FilePdfOutlined />}
                        size="small"
                        style={{ borderRadius: '6px' }}
                    />
                </Tooltip> */}
            </Space>
        ),
    },
];


export const columnsUtilisateurs = [
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
    },
    {
        title: "Nom & Prenom",
        dataIndex: "nom",
        key: "nom",
        render: (_, record) => (
            <>
                {record.personne?.nom} {record.personne?.prenom}
            </>
        )
    },
    {
        title: "Profil",
        dataIndex: "profil",
        key: "profil",
        render: (_, record) => (
            <>
                {record.profil?.nom}
            </>
        )
    },
    {
        title: "Agence",
        dataIndex: "agence",
        key: "agence",
        render: (_, record) => (
            <>
                {record.agence?.nom}
            </>
        )
    },
    {
        title: "Statut",
        dataIndex: "statut",
        key: "statut",
        render: (_, record) => (
            <>
                {record.active ? <Tag color="green">Actif</Tag> : <Tag color="red">Inactif</Tag>}
            </>
        )
    },
    {
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (_, record) => (
            <>
                <Link to={`/details-utilisateur/${record.codeId}`}><Button type="primary">Voir</Button></Link>
            </>
        )
    }
];